import React from 'react';
import { motion } from 'framer-motion';
import { FiGithub } from 'react-icons/fi';
import { glassCardHover } from '../../../styles/animations';
import {
  CardContainer,
  CardImage,
  CardContent,
  CardName,
  CardRole,
  CardDepartment,
  GitHubLink
} from './ManagementCard.styles';

function ManagementCard({ person, index, variant }) {
  return (
    <CardContainer
      as={motion.div}
      variants={glassCardHover}
      initial="rest"
      whileHover="hover"
      style={{ transitionDelay: `${index * 0.05}s` }}
      $variant={variant}
    >
      <CardImage
        $fitInside={person.id === 'jimal_14'}
        src={person.img || '/management-placeholder.svg'}
        alt={person.name}
        loading="lazy"
        onError={(event) => {
          if (!event.currentTarget.src.endsWith('/management-placeholder.svg')) {
            event.currentTarget.src = '/management-placeholder.svg';
          }
        }}
      />
      <CardContent>
        <CardName>{person.name}</CardName>
        <CardRole>{person.role}</CardRole>
        <CardDepartment>{person.department}</CardDepartment>
        {person.github && <GitHubLink
          href={person.github}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${person.name}'s GitHub`}
          as={motion.a}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
        >
          <FiGithub size={20} />
        </GitHubLink>}
      </CardContent>
    </CardContainer>
  );
}

export default ManagementCard;
